import { VITE_AEM_URL } from "@utils/constants.util"
import axios, { AxiosResponse } from "axios"
import { getAuthToken } from "./authService"
import { UserProfile } from "@models/userProfile.model"

interface ForexDataResponse {
	0: {
		rates: Record<string, number>
	}
}

export const getPrimaryCurrencyCode = (
	userProfile: UserProfile | null
): string | undefined => {
	return userProfile?.currencies?.find(
		(currency) => currency?.primaryCurrency === true
	)?.currencyCode
}

export const fetchForexData = async (
	userProfile: UserProfile | null,
	base?: string | undefined
) => {
	const primaryCurrencyCode = base || getPrimaryCurrencyCode(userProfile)
	if (!primaryCurrencyCode) {
		throw new Error("Primary currency not found")
	}

	try {
		const response: AxiosResponse<ForexDataResponse> = await axios.get(
			`${VITE_AEM_URL}/api/forex?base=${primaryCurrencyCode}`,
			{
				headers: {
					"Content-Type": "application/json",
					Authorization: `Bearer ${getAuthToken()}`,
					"edge-cache-tag": "forex"
				}
			}
		)
		return response.data[0]?.rates
	} catch (error) {
		throw new Error(`Failed to fetch forex data: ${error}`)
	}
}
